// extracted by mini-css-extract-plugin
export default {"RsConfirmationModalTrigger":"modal_RsConfirmationModalTrigger__pkH+I"};